import { each, equals2, go, rejectL } from "fxjs/es";
export const startCopy = (self) => {
  const empty_grid_layer_el = self._getEmptyGridLayerElThrowable();
  const copy_source_grid_layer_el = self._getCopySourceGridLayerElThrowable();
  const copy_destination_unselected_empty_grid_layer_el =
    self._getCopyDestinationUnselectedEmptyGridLayerElThrowable();
  const copy_destination_unselected_existing_grid_layer_el =
    self._getCopyDestinationUnselectedExistingGridLayerElThrowable();
  if (self._selected_grid_id == null) {
    throw new Error(`선택된 grid 가 없습니다.`);
  }
  const grid_id = self._selected_grid_id;
  const grid = self._grids.get(grid_id);
  if (grid == null) {
    throw new Error(`선택된 grid 를 찾을 수 없습니다.`);
  }
  const { target_image_el, copy_source_grid_el } = grid;
  if (target_image_el == null) {
    throw new Error(`빈 grid 를 복사할 수 없습니다.`);
  }
  self.selectGrid(null);
  copy_source_grid_layer_el.appendChild(copy_source_grid_el);
  go(
    self._grids.values(),
    rejectL((grid) => equals2(grid.id)(grid_id)),
    each(
      ({
        target_image_el,
        empty_grid_el,
        copy_destination_unselected_empty_grid_el,
        copy_destination_unselected_existing_grid_el,
      }) => {
        if (target_image_el == null) {
          if (empty_grid_layer_el.contains(empty_grid_el)) {
            empty_grid_layer_el.removeChild(empty_grid_el);
          }
          copy_destination_unselected_empty_grid_layer_el.appendChild(
            copy_destination_unselected_empty_grid_el
          );
          return;
        }
        copy_destination_unselected_existing_grid_layer_el.appendChild(
          copy_destination_unselected_existing_grid_el
        );
      }
    )
  );
  self._copy_source_grid_id = grid_id;
};
